module.exports = __webpack_public_path__ + "img-dashboard/register/breadcrumb-user.fa25270d.svg";